export default __webpack_public_path__ + "static/media/LoginBG.29a74cad.png";